export const SHOW_ALERT_MESSAGE = "SHOW_ALERT_MESSAGE";
export const HIDE_ALERT_MESSAGE = "HIDE_ALERT_MESSAGE";
